import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth/service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../shared/loader/loader.component';
@Component({
  selector: 'app-show-request-form-dailog',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule,LoaderComponent],
  templateUrl: './show-request-form-dailog.component.html',
  styleUrl: './show-request-form-dailog.component.scss'
})
export class ShowRequestFormDailogComponent implements OnInit {

  isLoading: boolean = false;
  agencyForm!: FormGroup
  isSubmitted: boolean = false;
  @Input() total_account_count: any;
  @Input() onCloseRedirect: any;
  @Input() agency_name: any;
  @Input() user_id: any;
  @Input() access_token: any;


  constructor(private formBuilder: FormBuilder, public activeModal: NgbActiveModal, private route: ActivatedRoute, public router: Router, private authService: AuthService, private toaster: ToastrService) {
    this.agencyForm = this.formBuilder.group({
      agencyName: ['', [Validators.required]],
      // comments: ['']
    });
    this.agencyForm.patchValue({
      agencyName: this.agency_name || ''
    })
  }

  ngOnInit() {
  }

  get agencyFormControl() {
    return this.agencyForm.controls;
  }

  onChange(event: any, controlName: string) {
    const value = event.target.value;
    this.agencyForm.get(controlName)?.setValue(value);
  }

  update() {
    this.isSubmitted = true;
    if (this.agencyForm.valid) {
      this.isLoading = true;

      let payload = {
        agency_name: this.agencyForm.get('agencyName')?.value
      }

      let headers = {
        Authorization: `Bearer ${this.access_token}`
      };

      this.authService.updateAgencyDetails(payload,headers).subscribe({
        next: (res) => {
          if (res.status == 'Success') {
            this.activeModal.close();
            if (res && res?.data) {
              if (res.data.status == 'show_token_page'){
                this.router.navigate(['/login/email-verification'],{ queryParams: { showForm: false } });
              }
              if (res.data.status == 'show_token_page_with_signup'){
                this.router.navigate(['/login/email-verification'],{ queryParams: { showForm: true } });
              }
              this.toaster.success(res.message,'',{
                timeOut: 5000,
                closeButton: true,
             });
            }else{
              if (this.total_account_count > 0) {
                this.router.navigate(['layout/activity'])
              } else {
                this.router.navigate(['layout'])
              }
            }
          }
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          if (!err.error.success) {
            this.toaster.error(err.error.message, '', {
              timeOut: 5000,
              closeButton: true,
            })
          }
        }
      })
    }
  }

  close() {
    this.activeModal.close();
    if (this.onCloseRedirect == 'layout') {
      if (this.total_account_count > 0) {
        this.router.navigate(['layout/activity'])
      } else {
        this.router.navigate(['layout'])
      }
    } else if (this.onCloseRedirect == 'login') {
      this.router.navigate(['/login'])
    }
  }
}
